import React from 'react';

interface CustomIconProps {
  width?: string;
  height?: string;
}

const ProductCartIcon: React.FC<CustomIconProps> = ({ width, height }) => (
  <svg
    width={width ?? '22'}
    height={height ?? '22'}
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='9.17627' cy='18.793' r='1.375' fill='#1C1C1C' />
    <circle cx='17.4263' cy='18.793' r='1.375' fill='#1C1C1C' />
    <path
      d='M0.916504 0.917969H4.58317L7.03984 13.1921M7.03984 13.1921C7.12366 13.6142 7.35325 13.9933 7.68842 14.2631C8.02359 14.5329 8.44298 14.6762 8.87317 14.668H17.7832C18.2134 14.6762 18.6328 14.5329 18.9679 14.2631C19.3031 13.9933 19.5327 13.6142 19.6165 13.1921L21.0832 5.5013H5.49984L7.03984 13.1921Z'
      stroke='#1C1C1C'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.04 13.1908L5.5 5.5H21.0833L19.6167 13.1908C19.5328 13.6129 19.3033 13.992 18.9681 14.2618C18.6329 14.5316 18.2135 14.6749 17.7833 14.6667H8.87333C8.44314 14.6749 8.02375 14.5316 7.68858 14.2618C7.35342 13.992 7.12382 13.6129 7.04 13.1908ZM14.0417 7.89629C14.0417 7.48208 13.7059 7.14629 13.2917 7.14629C12.8775 7.14629 12.5417 7.48208 12.5417 7.89629V9.3335H11.1045C10.6902 9.3335 10.3545 9.66929 10.3545 10.0835C10.3545 10.4977 10.6902 10.8335 11.1045 10.8335H12.5417V12.2707C12.5417 12.6849 12.8775 13.0207 13.2917 13.0207C13.7059 13.0207 14.0417 12.6849 14.0417 12.2707V10.8335H15.4789C15.8931 10.8335 16.2289 10.4977 16.2289 10.0835C16.2289 9.66929 15.8931 9.3335 15.4789 9.3335H14.0417V7.89629Z'
      fill='#1C1C1C'
    />
  </svg>
);

export default ProductCartIcon;
